import { render, staticRenderFns } from "./ChapterTemplate.vue?vue&type=template&id=72a5e0c0&scoped=true&"
import script from "./ChapterTemplate.vue?vue&type=script&lang=js&"
export * from "./ChapterTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a5e0c0",
  null
  
)

export default component.exports